"use client";
import React from "react";
import Image from "next/image";
import useTextColorBasedOnBackground from "@/src/hooks/useTextColorBasedOnBackground";
import { AudienceButtonProps } from "./types";

const AudienceButton: React.FC<AudienceButtonProps> = ({ item, onClick }) => {
  const textColor = useTextColorBasedOnBackground(item.bgColor);

  return (
    <button
      onClick={onClick}
      className={`
        w-full sm:max-w-[374px]
        h-[150px] sm:h-[200px] lg:h-[370px]
        flex flex-col items-center justify-center
        text-center font-semibold uppercase
        rounded-lg shadow-lg transition-transform transform hover:scale-105
        ${item.bgColor} ${textColor}
      `}
    >
      <span className="text-sm md:text-lg tracking-wide leading-5">
        {item.label}
      </span>
      <Image
        src="/ecoshopIcon.png"
        alt={`${item.label} Logo`}
        width={140}
        height={140}
        className="mt-2"
      />
    </button>
  );
};

export default AudienceButton;
